import React, { FunctionComponent } from 'react'
import styled from '@emotion/styled'

interface TableOfContentsProps {
  __html: string
}

const ToC = styled.div`
  position: absolute;
  height: 100%;
  top: 0;
  right: 30px;
  div {
    position: sticky;
    top: 10rem;
    width: 200px;
  }
  @media (max-width: 900px) {
    display: none;
  }
`

const Box = styled.div`
  p {
    font-weight: bold;
    font-size: 1.05rem;
    margin-bottom: 5px;
  }
  li {
    margin-bottom: 10px;
  }
  & ul {
    margin-left: 10px;
  }
  a {
    color: #838383;
  }
  a:hover {
    color: var(--active);
  }
`

const TableOfContents: FunctionComponent<TableOfContentsProps> = function ({
  __html,
}) {
  const tocItem =
    __html !== '' ? (
      <div>
        <Box dangerouslySetInnerHTML={{ __html }} />
      </div>
    ) : null
  return <ToC>{tocItem}</ToC>
}

export default TableOfContents
